<template>
  <div>
    <To :to="data.to" @updateTo="data.to = $event"></To>
    <FormInput label="Latitude" :value="data.latitude" hint="14.800006" @update="data.latitude = $event"></FormInput>
    <FormInput label="Longitude" :value="data.longitude" hint="75.399994" @update="data.longitude = $event"></FormInput>
    <ReplyMarkup :reply_markup="data.reply_markup" :actions="actions" @changeReplyMarkup="data.reply_markup = $event"></ReplyMarkup>
  </div>
</template>


<script>
import ReplyMarkup from '@/components/tasks/fields/ReplyMarkup.vue'
import To from '@/components/tasks/fields/To.vue'
import FormInput from '@/components/tasks/fields/FormInput.vue'



export default {
  name: 'SendLocation',
  components:{
    ReplyMarkup,
    To,
    FormInput
  },
  props: {
    data: Object,
    actions: Object
  },
  methods:{
  },


}
</script>
